import { mapActions, mapGetters } from "vuex";
import types from "../store/types";

export var timeTrack = {
  data() {
    return {
      sessionTimeoutWarning: 0,
      sessionTimeout: 0,
    };
  },
  created() {
    if (this.expiryTime !== "") {
      this.spawnTimeoutWarning();
      this.spawnTimeout();
    }
  },
  computed: {
    ...mapGetters([types.getters.expiryTime]),
  },
  beforeDestroy() {
    clearTimeout(this.sessionTimeoutWarning);
    clearTimeout(this.sessionTimeout);
  },
  methods: {
    ...mapActions([types.actions.refreshAccessToken, types.actions.logout]),
    spawnTimeoutWarning() {
      let warningTime = this.expiryTime - 10 * 60 * 1000;
      this.sessionTimeoutWarning = setTimeout(() => {
        this.$confirm(
          "Your session will expire in 10 minutes. Would you like to continue your booking?",
          "Session Expiration Warning",
          {
            confirmButtonText: "CONTINUE MY BOOKING",
            cancelButtonText: "EXIT",
            customClass: "session-expiry-box",
            showClose: false,
            type: "warning",
            closeOnPressEscape: false,
            closeOnClickModal: false,
            center: true,
          },
        )
          .then(() => {
            console.log("Continue checking in pressed");
            this[types.actions.refreshAccessToken]().then(() => {
              clearTimeout(this.sessionTimeout);
              clearTimeout(this.sessionTimeoutWarning);
              this.spawnTimeout();
              this.spawnTimeoutWarning();
            });
          })
          .catch(() => {});
      }, warningTime);
    },
    spawnTimeout() {
      this.sessionTimeout = setTimeout(() => {
        this[types.actions.logout]().then(() => {
          this.$router.push({ path: "/checkin-suspended" });
        });
      }, this.expiryTime);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/timeTrack.js